import { render, staticRenderFns } from "./reference-page.vue?vue&type=template&id=a849a886&scoped=true&"
import script from "./reference-page.vue?vue&type=script&lang=js&"
export * from "./reference-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a849a886",
  null
  
)

export default component.exports